import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Input, Dropdown, Loader, Button} from 'semantic-ui-react';
import TablePaginator from '../../../../common/components/tablePaginator';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {enterKeyCode} from '../../../../common/constants/keyCodes';
import {paths} from '../../../../common/dictionaries/urls';
import {pageSizes} from '../../../../common/constants/lists';
import {Actions} from '../../../../common/actions';
import './partWatchingList.scss';

class PartWatchingList extends Component {
  constructor(props) {
    super(props);
    this.onDescriptionFilterChange = this.onDescriptionFilterChange.bind(this);
    this.onCodeFilterChange = this.onCodeFilterChange.bind(this);
    this.checkEnterSubmit = this.checkEnterSubmit.bind(this);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PartWatching,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearFilters();
    this.props.changePartWatchingListPage(0);
  }

  onCodeFilterChange(event) {
    this.props.changeCodeTextFilter(event.target.value);
  }

  onDescriptionFilterChange(event) {
    this.props.changeDescriptionTextFilter(event.target.value);
  }

  onPageSizeClick(event, data) {
    this.props.changePartWatchingListPageSize(data.value);
    this.getParts(0, data.value);
  }

  checkEnterSubmit(event) {
    if (event.keyCode === enterKeyCode) {
      this.onSearch(0);
    }
  }

  onCancelClick() {
    this.props.clearFilters();
    this.props.changePartWatchingListPage(0);
  }

  onSearch(value = 0) {
    const {pageSize} = this.props;
    this.props.changePartWatchingListPage(value);
    this.getParts(value, pageSize);
  }

  getParts(pageNumber, pageSize) {
    const parameters = {};
    const {filterCodeText, filterDescriptionText} = this.props;

    if (filterCodeText !== '') {
      parameters.code = filterCodeText;
    }
    if (filterDescriptionText !== '') {
      parameters.description = filterDescriptionText;
    }
    this.props.fetchPartsList(parameters, pageSize, pageNumber);
  }

  onViewPart(code) {
    this.props.navigateTo(`/kpi/part-watching/${code.trim()}`);
  }

  renderParts() {
    const {loading, parts} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    return parts.map((element, index) => {
      return (
        <Table.Row
          key={index}
          onClick={() => this.onViewPart(element.code)}
        >
          <Table.Cell textAlign='center'>{element.code}</Table.Cell>
          <Table.Cell textAlign='center'>{element.name}</Table.Cell>
          <Table.Cell textAlign='center'>{element.franchise}</Table.Cell>
          <Table.Cell textAlign='center'>{element.productCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.pnc}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderPagination() {
    const {pageNumber, pageSize, partsCount} = this.props;
    if (partsCount <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={partsCount}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onSearch}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    const {filterCodeText, filterDescriptionText} = this.props;

    return (
      <div className='part-watching-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Part Watching</h2>
              <div className='title-bar-actions'>
                <Input
                  placeholder='Por código'
                  value={filterCodeText}
                  onChange={this.onCodeFilterChange}
                  onKeyUp={this.checkEnterSubmit}
                />
                <Input
                  placeholder='Por nombre'
                  value={filterDescriptionText}
                  onChange={this.onDescriptionFilterChange}
                  onKeyUp={this.checkEnterSubmit}
                />
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  onClick={this.onCancelClick}
                >
                  Limpiar
                </Button>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  onClick={() => this.onSearch(0)}
                >
                  Buscar
                </Button>
              </div>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Nombre</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Franquicia
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Código de producto
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>PNC</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderParts()}</Table.Body>

            {this.renderPagination()}
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partWatching.loadingList,
    'parts': state.partWatching.page,
    'filterCodeText': state.partWatching.filterCodeText,
    'filterDescriptionText': state.partWatching.filterDescriptionText,
    'pageNumber': state.partWatching.pageNumber,
    'pageSize': state.partWatching.pageSize,
    'partsCount': state.partWatching.itemsCount,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchPartsList,
  clearFilters,
  changeCodeTextFilter,
  changeDescriptionTextFilter,
  changePartWatchingListPage,
  changePartWatchingListPageSize,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchPartsList,
  clearFilters,
  changeCodeTextFilter,
  changeDescriptionTextFilter,
  changePartWatchingListPage,
  changePartWatchingListPageSize,
  navigateTo,
})(PartWatchingList);
